import PropTypes from "prop-types";

const propTypes = {
  numberOfOccupants: PropTypes.number.isRequired
};

export default propTypes;
